// extracted by mini-css-extract-plugin
export default {"modalOverlay":"uJ-z","modalContent":"vJ-z","header":"wJ-z","close":"xJ-z"};